import { Component, Input, OnInit } from '@angular/core';
import { BBResponseContainer } from '../carrier/response-container';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM } from '../masterdata/models/lab';
import { RedoReason } from '../masterdata/models/redoReason';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import * as cloneDeep from 'lodash/cloneDeep';
import * as omit from 'lodash/omit';

@Component({
  selector: 'app-redo-reasons',
  templateUrl: './redo-reasons.component.html',
  styleUrls: ['./redo-reasons.component.css']
})
export class RedoReasonsComponent implements OnInit {

  _masterLists: Array<RedoReason>;

  @Input() set masterLists(masterLists: Array<RedoReason>) {
    this._masterLists = (masterLists || []).map((redoReason: RedoReason) => {
      return Object.assign({}, redoReason, { defaultRedoStep: this.getDefaultRedoStepName(redoReason) });
    });
  }

  @Input() tableCols: Array<RedoReason>;

  @Input() title: string;

  @Input() labOptions: LabMDM[];

  errorHandler: ErrorHandler = new ErrorHandler();

  defaultRedoSteps: Array<any>;

  selecteRedoReason: any;

  redoReason: RedoReason;

  showRedoReasonDialog: boolean;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
    this.showError = this.showError.bind(this);
  }

  ngOnInit() {
    this.defaultRedoSteps = [
      { name: 'None', value: 'NONE' },
      { name: 'Not Defined', value: 'NOT_DEFINED' },
      { name: 'Redo Lysis', value: 'REDO_LYSIS' },
      { name: 'Redo PCR', value: 'REDO_PCR' }
    ];
  }

  onRowSelect(event: any) {
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    const { defaultRedoStep = '' } = data;
    this.redoReason = cloneDeep(data);
    this.redoReason.lab = this.labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.redoReason.defaultRedoStep = this.defaultRedoSteps.find((redoStep: any) => redoStep.name === defaultRedoStep);
    this.showRedoReasonDialog = true;
  }

  handleAddNewRedoReason() {
    this.redoReason = { defaultRedoStep: this.defaultRedoSteps[0] };
    this.showRedoReasonDialog = true;
  }

  handleSaveOrUpdate() {
    const { _id } = this.redoReason;
    if (this.isValid()) {
      const redoReason: RedoReason = Object.assign({}, this.redoReason, { defaultRedoStep: ((this.redoReason.defaultRedoStep || {}) as any).value });
      if (_id) {
        this._masterDataService.updateRedoReason(redoReason).subscribe((response: BBResponseContainer) => {
          const { data } = response;
          data.defaultRedoStep = this.getDefaultRedoStepName(data);
          const selectedRedoReasonIndex: number = this._masterLists.findIndex((redoReasonItem: RedoReason) => redoReasonItem._id === _id);
          this._masterLists[selectedRedoReasonIndex] = data;
          this.showRedoReasonDialog = false;
        }, this.showError);
      } else {
        this._masterDataService.saveRedoReason(redoReason).subscribe((response: BBResponseContainer) => {
          const { data } = response;
          data.defaultRedoStep = this.getDefaultRedoStepName(data);
          this._masterLists.push(data);
          this.showRedoReasonDialog = false;
        }, this.showError);
      }
    }
  }

  showError(error: any) {
    const { status } = error;
    if (status === 400) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Duplicate Key',
        detail: error.error.message
      });
    } else {
      let message = this.errorHandler.handleError(error);
      this._messageService.addErrorMessage(message);
    }
  }

  isValid() {
    const { reasonName = '', reasonCode = '', lab } = this.redoReason;
    this.redoReason = omit(this.redoReason, ['reasonNameError', 'reasonCodeError']);
    if (!reasonName.trim().length) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Reason Name',
        detail: 'Reason Name cannot be empty'
      });
      (this.redoReason as any).reasonNameError = true;
      return false;
    } else if (!reasonCode.trim().length) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Reason Code',
        detail: 'Reason Code cannot be empty'
      });
      (this.redoReason as any).reasonCodeError = true;
      return false;
    } else if (!lab) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Lab',
        detail: 'Please select the Lab'
      });
      return false;
    }
    return true;
  }

  private getDefaultRedoStepName(redoReason: RedoReason) {
    const { defaultRedoStep } = redoReason;
    const defaultRedoStepObj: any = this.defaultRedoSteps.find((redoStep: any) => redoStep.value === defaultRedoStep);
    return (defaultRedoStepObj || {}).name;
  }
}
